import { t } from '../../../shared/config/translations'
import { collectionSyncStatusText } from '../../components/collectionSyncStatus'
import { showSnackbar } from '../../components/Snackbar'
import {
	getCollectionStoreState,
	subscribeCollectionStore,
	syncCollectionFromDiscogs,
} from '../../stores/collectionStore'

const STATUS_INTERVAL_MS = 60 * 1000

/** Web counterpart of native pull-to-refresh; the new snapshot refreshes the page. */
export function bindCollectionSyncControls(rootEl: HTMLElement): () => void {
	const button = rootEl.querySelector<HTMLButtonElement>(
		'[data-collection-sync-button]',
	)
	const statusEl = rootEl.querySelector<HTMLElement>(
		'[data-collection-sync-status]',
	)
	if (!button) return () => {}
	let disposed = false
	let starting = false

	const render = () => {
		if (disposed) return
		const busy = starting || getCollectionStoreState().phase === 'syncing'
		button.disabled = busy
		button.setAttribute('aria-busy', String(busy))
		if (statusEl) statusEl.textContent = collectionSyncStatusText()
	}

	const onClick = async () => {
		starting = true
		render()
		try {
			await syncCollectionFromDiscogs()
		} catch {
			if (!disposed) showSnackbar(t('refresh.failed'), 'error')
		} finally {
			starting = false
			render()
		}
	}

	button.addEventListener('click', onClick)
	const unsubscribe = subscribeCollectionStore(render)
	const timer = setInterval(render, STATUS_INTERVAL_MS)
	render()

	return () => {
		disposed = true
		clearInterval(timer)
		unsubscribe()
		button.removeEventListener('click', onClick)
	}
}
